exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar {\n  border: 1px;\n  border-style: solid;\n  border-color: silver;\n  width: 200px;\n  height: 200px;\n  margin-top: 1rem; }\n\n.spaceName {\n  margin-left: 0.2rem;\n  font-weight: bold; }\n\n.container {\n  width: 50%; }\n\n.infoWrapper {\n  margin-top: 1rem;\n  padding: 1rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n\n.table th,\n.table td {\n  padding: 0rem;\n  padding-right: 0.75rem; }\n\n.secSym {\n  text-align: center; }\n\n.startDate {\n  text-align: center; }\n\n.position {\n  text-align: left; }\n\n.header-board {\n  padding-top: 1rem;\n  padding-bottom: 1rem; }\n\n.upload-section {\n  cursor: pointer;\n  position: relative;\n  border-radius: 8px;\n  margin-top: -39px;\n  padding: 0 10px;\n  width: 60%; }\n\n.upload-section input[type='file'] {\n  cursor: pointer;\n  -webkit-appearance: none;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0; }\n\n.last-news {\n  font-weight: bold;\n  text-indent: 0.5rem;\n  border: 1px solid #e1e6ef;\n  background-color: #e1e6ef; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/bod/bod-info/bod-info.component.scss
// module id = ../../../../../src/app/securities-level/bod/bod-info/bod-info.component.scss
// module chunks = main